import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { Link } from 'react-router-dom';
import styles from '../OnboardingRouter/styles.sass';
import SignupForm from '../SignupForm';

import Box from '../../shared/Box';
import Text from '../../shared/Text';
import events from '../SignupPageContainer/events';

// This is currently built only for onboarding
const SignupPage = ({
  error,
  routing,
  onSubmit,
  anyTouched,
  submitting,
  onClickRequestResetPassword,
}) => (
  <div className={`${styles.onboardingPage} `}>
    <div className={`${styles.pageContent} `}>
      <Row>
        <Col xs={12}>
          <div className={styles.signupPage}>
            <h1 key="title">Sign up for Anchor</h1>
            <Box marginBottom={50} marginTop={12}>
              <Text size="xl" color="#292f36">
                Already have an account?{' '}
                <Text size="xl" color="#8940fa" isBold isInline>
                  <Link to="/login" onClick={events.signUpSignInButtonClicked}>
                    Log in
                  </Link>{' '}
                </Text>
                instead.
              </Text>
            </Box>
            <SignupForm
              anyTouched={anyTouched}
              error={error}
              onSubmit={onSubmit}
              routing={routing}
              submitting={submitting}
              location={routing.location}
              onClickRequestResetPassword={onClickRequestResetPassword}
            />
            <p className={`${styles.loginText} ${styles.centered}`}>
              You can also{' '}
              <Link to="/switch" onClick={events.signUpImportButtonClicked}>
                import
              </Link>{' '}
              an existing podcast.
            </p>
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default SignupPage;
